import { useState } from "react";
import Button from "@material-ui/core/Button";
import clsx from "clsx";

function MainButton(props) {
  const [is_loading, setLoading] = useState(false);
  // Error label shown instead of the children until the next successful click
  const [error, setError] = useState(null);

  async function handleClick(event) {
    setLoading(true);
    let result;
    try {
      result = await props.onClick(event);
    } catch (e) {
      console.log(e);
      result = null;
    }

    if (result?.hasOwnProperty("completed") && !result.completed) {
      switch(result.status) {
        case 429:
          setError(<>Ошибка. Слишком<br />много запросов</>);
          break;
        default:
          setError(<>Ошибка. {props.children}</>);
      }
    } else if (!result || result.hasOwnProperty("error")) {
      setError(result?.error_text || props.error || <>Ошибка. {props.children}</>); // error_text используется только при авторизации Telegram
    } else {
      setError(null);
    }
    setLoading(false);
  }

  return <Button
    classes={{ disabled: "submit-disabled", }}
    className={clsx("submit-button", props.className)}
    onClick={event => handleClick(event)}
    id={props.id}
    disabled={is_loading || props.disabled}
  >
    {is_loading ? props.loading || "Загрузка..." : error ?? props.children}
  </Button>;
}

function NoloadButton(props) {
  return <Button
    classes={ {disabled: "submit-disabled",} }
    className={clsx("submit-button", props.className)}
    onClick={event => props.onClick?.(event)}
    id={props.id}
    disabled={props.disabled}
  >
    {props.children}
  </Button>;
}

function SecondaryButton(props) {
  return <Button
    className={clsx("secondary-button", props.className)}
    onClick={event => props.onClick?.(event)}
    id={props.id}
  >
    {props.children}
  </Button>;
}

export default MainButton;
export { NoloadButton, SecondaryButton };
